import { ToggleButton, ToggleButtonGroup, styled, toggleButtonGroupClasses } from '@mui/material'

const DayUnitToggle = ({ dayUnit = '365d', setDayUnit }) => {
  const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    [`& .${toggleButtonGroupClasses.grouped}`]: {
      margin: theme.spacing(0.5),
      border: 0,
      borderRadius: theme.shape.borderRadius,
      [`&.${toggleButtonGroupClasses.disabled}`]: {
        border: 0,
      },
    },
    [`& .${toggleButtonGroupClasses.middleButton},& .${toggleButtonGroupClasses.lastButton}`]: {
      marginLeft: -1,
      borderLeft: '1px solid transparent',
    },
  }))
  return (
    <StyledToggleButtonGroup
      color="primary"
      value={dayUnit}
      exclusive
      onChange={(e, v) => setDayUnit(v)}
      size="small"
      maxWidth="100%"
      sx={{
        height: { lg: '40px', md: '40px', sm: '45px', xs: '45px' },
        width: { lg: '140px', md: '140px', sm: '100%', xs: '100%' },
        border: '1px solid #CBD2DB',
        justifyContent: 'space-between',
      }}
    >
      <ToggleButton
        value="7d"
        sx={{
          '&.Mui-selected': {
            background: '#C4CAF1',
            color: '#3747B0',
            fontSize: '14px',
            fontWeight: '900',
          },
          '&.MuiToggleButton-sizeSmall': { borderRadius: '4px!important', width: '25%', maxWidth: '40px' },
        }}
      >
        W
      </ToggleButton>
      <ToggleButton
        value="30d"
        sx={{
          '&.Mui-selected': {
            background: '#C4CAF1',
            color: '#3747B0',
            fontSize: '14px',
            fontWeight: '900',
          },
          '&.MuiToggleButton-sizeSmall': { borderRadius: '4px!important', width: '25%', maxWidth: '40px' },
        }}
      >
        M
      </ToggleButton>
      <ToggleButton
        value="90d"
        sx={{
          '&.Mui-selected': {
            background: '#C4CAF1',
            color: '#3747B0',
            fontSize: '14px',
            fontWeight: '900',
          },
          '&.MuiToggleButton-sizeSmall': { borderRadius: '4px!important', width: '25%', maxWidth: '40px' },
        }}
      >
        Q
      </ToggleButton>
      <ToggleButton
        value="365d"
        sx={{
          '&.Mui-selected': {
            background: '#C4CAF1',
            color: '#3747B0',
            fontSize: '14px',
            fontWeight: '900',
          },
          '&.MuiToggleButton-sizeSmall': { borderRadius: '4px!important', width: '25%', maxWidth: '40px' },
        }}
      >
        Y
      </ToggleButton>
    </StyledToggleButtonGroup>
  )
}

export default DayUnitToggle
